import React from "react";
import SectionHeading from "../components/SectionHeading";
import frame from "../assets/frame.jpg";

export default function ContactPage() {
  return (
    <section className="pb-20">
      <div className="pb-12">
        <div>
          <img
            className="w-full h-[50vh] object-cover object-center"
            src={frame}
            alt="Dandelion Bee"
          />
        </div>
      </div>
      <div className="mx-auto grid max-w-7xl gap-8 md:grid-cols-[0.9fr_1.1fr]">
        <div>
          <SectionHeading
            eyebrow="Contact"
            title="Get in touch."
            description="Reach out and ask about queens, nucs, seasonal availability, or hive placement and mangement."
          />

          <div className="mt-8 space-y-4 text-base leading-7 text-slate-600">
            <p>
              <span className="font-semibold text-slate-900">Email:</span>{" "}
              hello@cedarandcomb.com
            </p>
            <p>
              <span className="font-semibold text-slate-900">Instagram:</span>{" "}
              @cedarandcombPNW
            </p>
            <p>
              <span className="font-semibold text-slate-900">Location:</span>{" "}
              Olympia, Washington
            </p>
          </div>
        </div>

        <div className="rounded-[2.25rem] border border-white/70 bg-white p-8 shadow-glow md:p-10">
          <div className="grid gap-5">
            <div>
              <label className="mb-2 block text-sm font-semibold text-slate-700">
                Name
              </label>
              <input
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 outline-none transition focus:border-amber-400 focus:bg-white"
                placeholder="Your name"
              />
            </div>
            <div>
              <label className="mb-2 block text-sm font-semibold text-slate-700">
                Email
              </label>
              <input
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 outline-none transition focus:border-amber-400 focus:bg-white"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <label className="mb-2 block text-sm font-semibold text-slate-700">
                What are you looking for?
              </label>
              <select className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 outline-none transition focus:border-amber-400 focus:bg-white">
                <option>Queen availability</option>
                <option>Nucs</option>
                <option>Hive Management</option>
                <option>Beekeeping help</option>
                <option>General inquiry</option>
              </select>
            </div>
            <div>
              <label className="mb-2 block text-sm font-semibold text-slate-700">
                Message
              </label>
              <textarea
                rows="5"
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 outline-none transition focus:border-amber-400 focus:bg-white"
                placeholder="Tell Cedar & Comb what you need"
              />
            </div>
            <button className="rounded-full bg-forest px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:shadow-glow">
              Send inquiry
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
